import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle, Circle } from "@phosphor-icons/react";
import api from "@/lib/api";
import { BTN_BLACK } from "@/components/pageSettings/AdminModal";
import { setupUrl } from "./StepShell";

// Buyer setup progress on Manage buyer; each step opens the guided setup there.
export function SetupChecklist({ orgId }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get(setupUrl(orgId)).then((r) => setS(r.data)).catch(() => setS(null));
  }, [orgId]);
  if (!s) return null;
  const next = s.steps.find((x) => !x.done);
  const done = s.steps.filter((x) => x.done).length;
  return (
    <div className="brut-card bg-white p-4" data-testid="buyer-setup-checklist">
      <div className="flex items-center gap-2 flex-wrap">
        <div className="font-chivo font-black uppercase tracking-tighter text-sm">Buyer setup</div>
        <span className="label-mono text-zinc-600" data-testid="buyer-setup-count">{done} of {s.steps.length} done</span>
        <span className={`border-2 border-black px-1.5 text-[10px] uppercase tracking-widest ${s.live ? "bg-emerald-600 text-white" : "bg-zinc-200"}`} data-testid="buyer-setup-live-chip">
          {s.live ? "Live" : "Not live"}
        </span>
        <Link to={`/clients/${orgId}/setup${next ? `?step=${next.key}` : ""}`} className={`${BTN_BLACK} ml-auto`} data-testid="buyer-setup-open">
          {next ? "Continue setup" : "Open setup"}
        </Link>
      </div>
      <ol className="grid grid-cols-1 sm:grid-cols-5 gap-2 mt-3">
        {s.steps.map((x, i) => (
          <li key={x.key}>
            <Link to={`/clients/${orgId}/setup?step=${x.key}`} data-testid={`buyer-setup-item-${x.key}`}
                  className="h-full border-2 border-black p-2 flex gap-2 hover:bg-zinc-100 transition-colors duration-100">
              {x.done ? <CheckCircle size={16} weight="fill" className="text-emerald-600 shrink-0" /> : <Circle size={16} weight="bold" className="shrink-0" />}
              <span className="min-w-0">
                <span className="block text-[10px] uppercase tracking-widest font-bold">{i + 1}. {x.label}</span>
                <span className="block text-[11px] text-zinc-500 leading-snug">{x.done ? "Done" : x.note}</span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}
